import { LegacyTimelinePosts } from './LegacyTimelinePosts';

export { LegacyTimelinePosts };
export default LegacyTimelinePosts;
